import { FIRST_PAGE, HALF_PAGE_RANGE, PAGE_RANGE } from './constants'
type PaginationItems = Array<{ active: boolean; page: number }>

export function createRenderedPaginationList(activePage: number, pageCount: number): PaginationItems {
  if (activePage > pageCount) {
    throw new Error(`activePage (${activePage}) cannot be grater than pageCount (${pageCount})!`)
  }

  const initialfirstPage = activePage <= HALF_PAGE_RANGE ? FIRST_PAGE : activePage - HALF_PAGE_RANGE
  const initialLastPage = activePage >= pageCount - HALF_PAGE_RANGE ? pageCount : initialfirstPage + PAGE_RANGE

  const lastPage = initialLastPage > pageCount ? pageCount : initialLastPage
  const firstPage = lastPage - PAGE_RANGE <= 0 ? FIRST_PAGE : lastPage - PAGE_RANGE

  // Generated range of pages
  const pages = Array.from(Array(Math.floor(lastPage - firstPage + 1)), (p, index) => index + firstPage)
  const generatedPages: PaginationItems = pages.map((page, index) => {
    const actual = {
      active: page === activePage,
      page,
    }

    return actual
  })

  return generatedPages
}



// WEBPACK FOOTER //
// ./src/app/shared/pagination/utils.ts